// AppTabs Component
import _ from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import './index.scss';
import KTTooltip from '../OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';

AppTabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.array,
  activeTab: PropTypes.string,
  handleClick: PropTypes.func,
  additionalClassName: PropTypes.string,
  setTab: PropTypes.func,
  disabledTabs: PropTypes.array,
  hasTabInfo: PropTypes.bool,
};

function AppTabs({
  className = '',
  tabs = [],
  activeTab,
  handleClick,
  additionalClassName = '',
  setTab,
  disabledTabs = [],
  hasTabInfo = false,
}) {
  const { t } = useTranslation();
  const id = uuidv4();

  if (_.isEmpty(activeTab)) {
    activeTab = tabs[tabs.length - 1];
  }

  const onClick = (tab, e) => {
    if (disabledTabs.includes(tab)) {
      e.preventDefault();
      return;
    }
    if (handleClick) {
      handleClick(tab);
    }
  };

  useEffect(() => {
    const allTabs = document.getElementById(id).getElementsByClassName('tab');
    for (let i = 0; i < allTabs.length; i++) {
      allTabs[i].addEventListener('click', function () {
        if (this.classList.contains('active') || this.classList.contains('disabled')) {
          return;
        }

        const parent = this.parentNode;
        const innerTabs = parent.querySelectorAll('.tab');

        for (let index = 0; index < innerTabs.length; index++) {
          innerTabs[index].classList.remove('active');
        }

        this.classList.add('active');
      });
    }

    return () => {
      for (let i = 0; i < allTabs.length; i++) {
        allTabs[i].removeEventListener('click', () => { });
      }
    };
  }, []);

  return (
    <div className={'bg-transparent Tabs_Container ' + className} id={id}>
      <div className={`tabbed round d-flex flex-row-reverse justify-content-end ${additionalClassName}`}>
        {!hasTabInfo
          ? tabs.map((text, index) => (
            <div
              key={index}
              className={`tab ${text === activeTab ? 'active' : ''} ${disabledTabs.includes(text) ? 'disabled' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                onClick(text, e);
                if (setTab && !disabledTabs.includes(text)) {
                  setTab(text);
                }
              }}
            >
              {t(text)}
            </div>
          ))
          : tabs.map((tab, index) => (
            <div
              key={index}
              className={`tab ${tab.name === activeTab ? 'active' : ''} ${disabledTabs.includes(tab.name) ? 'disabled' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                onClick(tab.name, e);
                if (setTab && !disabledTabs.includes(tab.name)) {
                  setTab(tab.name);
                }
              }}
            >
              {t(tab.name)}
              <span className='ml-1'>
                {tab?.description && (
                  <KTTooltip
                    text={tab?.description?.text}
                    textHeader={tab?.description?.textHeader}
                  // isHtmlContent
                  >
                    <i
                      className="fa-regular fa-info-circle"
                      style={{ color: AppColors.info }}
                    />
                  </KTTooltip>
                )}
              </span>
            </div>
          ))}
      </div>
    </div>
  );
}

export default AppTabs;